import { Head, Section } from './ui';
const steps = [
  ['Build Your Network', 'Introduce everyday active consumers and genuine commercial retail/service businesses to SELECTEZI', 'Step 1: Introduction', 'person-plus'],
  ['Qualify Your Connections', 'Ensure accounts undergo contact verification, complete profile details, and show genuine platform interactions', 'Step 2: Validation', 'card-checklist'],
  ['Achieve Your Star', 'Meet the cumulative dual benchmark (Qualified Users + Business Shops) to secure your rank advancement', 'Step 3: Milestone', 'award'],
  ['Unlock Commission', 'Your Star tier determines your commission rate, rewarded against real platform economic transactions', 'Step 4: Yield', 'currency-dollar'],
  ['Grow, Lead & Expand', 'Recruit sub-agents at Star 6+, unlock team overrides, and expand into cross-border bilateral hubs', 'Step 5: Governance', 'globe'],
];
export default function HowItWorks() {
  return (
    <Section>
      <Head pill="5-Stage execution framework" title="How the Star System works" text="Follow the clear progression from connecting community businesses to earning enterprise prestige." />
      <div className="row g-3 row-cols-1 row-cols-md-2 row-cols-lg-5 align-items-start">
        {steps.map(([t, d, f, ic], i) => {
          const last = i === 4;
          return (
            <div className="col" key={t}>
              <div className={`rounded-4 p-3 border ${last ? 'bg-navy text-white' : 'bg-soft'}`}>
                <div className="d-flex justify-content-between mb-3">
                  <span className={`fw-bold rounded-3 px-3 py-2 ${last ? 'bg-gold text-navy' : i === 2 ? 'bg-navy text-gold' : 'bg-blue text-white'}`}>{i + 1}</span>
                  <i className={`bi bi-${ic} ${last ? 'text-white' : 'text-blue'}`} />
                </div>
                <h6 className="fw-bold">{t}</h6>
                <p className={`t-sm ${last ? 'text-white-50' : 'text-muted2'}`}>{d}</p>
                <div className={`border-top pt-3 t-xs fw-bold text-uppercase ${i % 2 && i !== 3 ? 'text-blue' : i === 2 ? 'text-gold' : 'text-blue'} ${last ? 'text-gold' : ''}`}>{f}</div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="bg-soft border rounded-4 p-3 mt-4 d-flex align-items-center gap-3 fw-bold t-sm text-uppercase">
        <i className="bi bi-shield-check bg-blue text-white rounded-3 p-2" />
        <span>Compliance requirement: registration alone does not guarantee commission payment, connections must meet all phone/identity verification and minimum activity criteria under SELECTEZI guidelines</span>
      </div>
    </Section>
  );
}
